import React, { useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import Configurator from '../components/configurator/Configurator';
import SummaryOptions from '../components/configurationOptions/SummaryOptions';
import WardrobeSummaryPopUp from '../components/popup/WardrobeSummaryPopUp';
import ShareSocialMediaPopUp from '../components/popup/ShareSocialMediaPopUp';
import ShareSendEmailPopUp from '../components/popup/ShareSendEmailPopUp';
import ShareGetShortUrlPopUp from '../components/popup/ShareGetShortUrlPopUp';
import { connect } from 'react-redux';
import { getConfiguration } from '../store/actions/configuration';
import ProgressBar from '../components/ProgressBar';
import ReactGA from 'react-ga';
import { WardrobesConfigsContext } from '../contexts/WardrobesConfigsContext';
import { ActiveWardrobeContext } from '../contexts/ActiveWardrobeContext';
import { EventsDataContext } from '../contexts/EventsDataContext';

const SummaryScreen = props => {
  const { shortToken } = useParams();
  const { dispatch } = props;
  const { wardrobesConfigs } = useContext(WardrobesConfigsContext);
  const { activeWardrobe } = useContext(ActiveWardrobeContext);
  const { setOptionsVisibility } = useContext(EventsDataContext);

  const wardrobe = wardrobesConfigs[activeWardrobe] || null;

  useEffect(() => {
    ReactGA.event(
      {
        category: 'Summary',
        action: 'Wardrobes summary',
        transport: 'beacon',
      },
      ['tracker1', 'tracker2'],
    );
  }, []);

  useEffect(() => {
    if (shortToken) {
      dispatch(getConfiguration(shortToken));
    }
  }, [dispatch, shortToken]);

  useEffect(() => {
    setOptionsVisibility(prev => ({ ...prev, optionsButton: false }));
    document.body.classList.remove('overlay');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wardrobesConfigs]);

  if (!wardrobe) {
    return null;
  }

  return (
    <Configurator>
      <ProgressBar />
      <ShareSocialMediaPopUp />
      <ShareSendEmailPopUp />
      <ShareGetShortUrlPopUp />
      <WardrobeSummaryPopUp />
      <SummaryOptions />
    </Configurator>
  );
};

export default connect()(SummaryScreen);
